import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaCanalizaciones from './TablaCanalizaciones';

const Canalizaciones: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaCanalizaciones />
  </Box>
);

export default Canalizaciones;
